export enum WishlistUpdateMode {
    Add = 'add',
    Delete = 'delete',
}
